export default __webpack_public_path__ + "static/media/96.df22e4fd.jpg";